var path = 'user/user-card.tpl.html';
var html = " <div class=tb-uppercase>{{item ? ( ( item.firstName ? item.firstName : '' ) + ' ' + ( item.lastName ? item.lastName : '') ) : ''}}</div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/user/user-card.tpl.html
// module id = 1470
// module chunks = 1